"use strict";

exports.__esModule = true;
exports["default"] = SocialYoutubeInverted;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SocialYoutubeInverted(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M256 137.7c-165.7 0-165.7 0-165.7 117.4s0 117.4 165.7 117.4 165.7 0 165.7-117.4 0-117.4-165.7-117.4zm-36.3 165.7v-96.6l93.2 48.3-93.2 48.3z",
    fill: "#939496"
  }));
}